import {ReactNode} from 'react';

export const ModalHeaderContainer = ({children}: {children: ReactNode}) => <div className="pb-2">{children}</div>;
